import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & + & {
    padding-left: 32px;
    margin-left: 32px;
    border-left: 2px dashed #ddd;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & + & {
    margin-top: 8px;
  }
`;

export const Value = styled.div`
  display: inline-block;
  text-align: right;
  width: 25%;

  &:first-child {
    text-align: left;
    width: 50%;
  }
`;

export const Header = styled(Value)`
  font-weight: 600;
  color: #0078D4;
  text-transform: uppercase;
`;
